import { render, staticRenderFns } from "./DeleteOrg.vue?vue&type=template&id=02d50554"
import script from "./DeleteOrg.vue?vue&type=script&lang=js"
export * from "./DeleteOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports